import { PropsWithChildren, ReactNode, useMemo } from 'react';
import { TPostMedia } from 'types';
import { VIDEO_ACCEPTED } from '../../constants';
import { Avatar, Carousel } from 'components';

type Props = PropsWithChildren<{
  data: TPostMedia[];
  selectedMediaIndex?: number;
  showThumbs?: boolean;
  showDots?: boolean;
  loop?: boolean;
  autoPlay?: boolean;
}>;

function MediaSlide({
  data,
  selectedMediaIndex = 0,
  showThumbs,
  showDots,
  loop,
  autoPlay,
}: Props) {
  const thumbChildren: ReactNode = useMemo(
    () =>
      showThumbs
        ? data.map(({ url, type }, index) => {
            return (
              <div key={`thumb-${index}`}>
                {VIDEO_ACCEPTED.includes(type) ? (
                  <video
                    controls
                    muted
                    loop
                    className="w-full h-full object-cover"
                  >
                    <source src={url} />
                  </video>
                ) : (
                  <Avatar url={url} />
                )}
              </div>
            );
          })
        : null,
    [data, showThumbs]
  );

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Carousel
        selectedMediaIndex={selectedMediaIndex}
        thumbsChildren={thumbChildren}
        showDots={showDots}
        loop={loop}
        autoPlay={autoPlay}
      >
        {data.map(({ url, type }, index) => {
          return (
            <div key={`slides-${index}`}>
              {VIDEO_ACCEPTED.includes(type) ? (
                <video controls autoPlay muted playsInline loop>
                  <source src={url} />
                </video>
              ) : (
                <Avatar url={url} className="!aspect-auto" />
              )}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
}

export default MediaSlide;
